///
/// EarthBrowser
///
/// Formatting utilities
///
/// Created by Matt Giger on December 23, 2025
/// Copyright (c) 2025 Geodata Labs
///

/**
 * Format bytes as human-readable string
 */
export function formatBytes(bytes: number, decimals: number = 2): string {
	if (bytes === 0) return '0 Bytes'

	const k = 1024
	const dm = decimals < 0 ? 0 : decimals
	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']

	const i = Math.floor(Math.log(bytes) / Math.log(k))

	return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

